import { z } from "zod";

/* Filters also have their own API endpoint, but for now we expect to
   only use them nested within groundwaterstations. */

import { baseModelSchema } from "./assetsBase";

export const filterSchema = baseModelSchema.extend({
  url: z.string(),
  id: z.number(),
  timeseries: z.array(z.string()),
  code: z.string(),
  groundwater_station: z.string() /* URL */,
  top_level: z.number().nullable(),
  filter_top_level: z.number().nullable(),
  filter_bottom_level: z.number().nullable(),
  aquifer_confinement: z.string().nullable(),
  lithology: z.string().nullable(),
  high_groundwater_level: z.number().nullable(),
  low_groundwater_level: z.number().nullable(),
});

export type Filter = z.infer<typeof filterSchema>;
